import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { settledAmount, } from '@debbie/common/dist/economy/payment-plans/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import Money from '../../Money.js';
const SettlementProgress = (props) => {
    const lang = useSelector((s) => s.lang);
    const settlementTotal = props.paymentPlan.config?.settlementTotal;
    if (settlementTotal == null) {
        return null;
    }
    const settledSum = settledAmount(props.paymentPlan.plan);
    const currentBalance = -helpers.overview.balance(props.caseVouchers);
    const originalDebt = currentBalance + settledSum;
    const forgiven = Math.max(0, originalDebt - settlementTotal);
    // A case paid in full outside the plan finishes it with entries still
    // pending, so cap what the settlement still demands at the case balance.
    const remainingToPay = Math.max(0, Math.min(settlementTotal - settledSum, currentBalance));
    return (React.createElement(StatsGrid, null,
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.settlementAgreedTotal),
            React.createElement(StatValue, null,
                React.createElement(Money, { amount: settlementTotal, currency: props.currency }))),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.settlementSettledSoFar),
            React.createElement(StatValue, null,
                React.createElement(Money, { amount: settledSum, currency: props.currency }))),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.settlementRemainingToPay),
            React.createElement(StatValue, null,
                React.createElement(Money, { amount: remainingToPay, currency: props.currency }))),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.settlementForgivenOnCompletion),
            React.createElement(StatValue, null,
                React.createElement(Money, { amount: forgiven, currency: props.currency })))));
};
export default SettlementProgress;
const StatsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
`;
const StatCard = styled.div `
  background: #fff;
  border: 1px solid ${THEME.BORDER};
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const StatLabel = styled.span `
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${THEME.TEXT_MUTED};
  font-weight: 600;
`;
const StatValue = styled.span `
  font-size: 15px;
  font-weight: 600;
  color: #222;
`;
//# sourceMappingURL=SettlementProgress.js.map